"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Brand = void 0;
var Brand;
(function (Brand) {
    Brand["AUDI"] = "audi";
    Brand["SEAT"] = "seat";
    Brand["SKODA"] = "skoda";
    Brand["VW"] = "vw";
    Brand["VWCV"] = "vwcv";
    Brand["DF"] = "df";
})(Brand || (exports.Brand = Brand = {}));
//# sourceMappingURL=brands.js.map